module.exports = __webpack_public_path__ + "static/media/PD_04.3c2e8df6.jpg";